import { useSelector } from 'react-redux';
import { useGetUserByIdQuery } from '../store/api/user.api';

export const useDbUserId = () => {
	const tgId = useSelector(state => state.user.user?.id);
	const { data: user, isLoading, isError } = useGetUserByIdQuery(tgId, {
		skip: !tgId,
	});

	return {
		dbUserId: user?.id,
		tgId,
		isLoading,
		isError,
		user,
	};
};
